export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            关于蓝莓影院
          </h2>
        </div>

        <div className="bg-background-50 rounded-lg p-6 md:p-8 border border-background-200/70">
          <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            <p>
              蓝莓影院是一个专注于电视剧全集免费在线观看的综合性追剧平台。网站收录海量电视剧资源，涵盖热播新剧与经典老剧，
              每日同步更新，致力于为广大追剧爱好者提供高清、流畅、不缓冲的优质观影体验。
            </p>
            <p>
              平台以用户需求为核心，对剧集内容进行精细化分类与专题策划，设有精选专题、热播榜单、热门话题、剧集索引等模块，
              帮助用户快速找到感兴趣的电视剧。无论您是古装剧爱好者、悬疑推理迷还是都市情感追随者，都能在蓝莓影院找到满意的剧集选择。
            </p>
            <p>
              自上线以来，蓝莓影院始终坚持免费开放的原则，无需注册登录，无需会员付费，以简洁高效的访问体验赢得了众多剧迷的信赖与推荐。
              我们持续优化播放技术，确保全平台设备均可流畅播放高清画质内容，让追剧变得更加轻松愉悦。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}